import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, Loader2Icon } from 'lucide-react';
import { ProgressBar } from './ProgressBar';
type LoadingBunnyProps = {
  skipProgress?: boolean;
  onProgressComplete?: () => void;
  messages?: string[];
};
export const LoadingBunny = ({
  skipProgress,
  onProgressComplete,
  messages = []
}: LoadingBunnyProps) => {
  const navigate = useNavigate();
  const messagesEndRef = useRef<HTMLDivElement>(null);
  // Auto scroll to bottom when new messages arrive
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [messages]);
  return <div className="fixed inset-0 bg-[#FFFAE4] flex flex-col items-center justify-center p-4 z-50" data-id="element-631">
      <div className="absolute top-4 left-4" data-id="element-632">
        <button onClick={() => navigate('/garden')} className="flex items-center px-4 py-2 text-[#6B4B3E] hover:bg-[#E5C1A9]/20 rounded-full transition-colors" data-id="element-633">
          <ChevronLeftIcon size={20} className="mr-2" data-id="element-634" />
          Story Garden
        </button>
      </div>
      <div className="max-w-lg w-full mx-auto text-center space-y-8" data-id="element-635">
        <h1 className="text-4xl md:text-5xl font-bold text-[#6B4B3E] mb-4" data-id="element-636">
          Story Bunny is writing your story!
        </h1>
        <div className="relative w-40 h-40 md:w-48 md:h-48 mx-auto" data-id="element-637">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vUW8wfs9hkip6tg4HcUqH2/ChatGPT_Image_May_18%2C_2025_at_09_24_15_AM.png" alt="Story Bunny" className="w-full h-full object-contain" data-id="element-638" />
          <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 flex items-center justify-center bg-white rounded-full p-2 shadow-lg" data-id="element-639">
            <Loader2Icon size={24} className="text-[#D4A088] animate-spin" data-id="element-640" />
          </div>
        </div>
        <p className="text-2xl text-[#6B4B3E] mt-8 mb-4" data-id="element-641">
          It'll be ready in just a minute!
        </p>
        <div className="w-full max-w-md mx-auto" data-id="element-642">
          <ProgressBar duration={80000} skipToEnd={skipProgress} onComplete={onProgressComplete} messages={messages} data-id="element-643" />
        </div>
      </div>
    </div>;
};